import React from "react";

export const FlexFiller = () => {
  return (
    <div style={{flex:'1 0 auto'}}></div>
  )
};
